import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { routerMiddleware } from 'connected-react-router'
import rootSaga from "./sagas";
import createRootReducer from './reducers'
import { signOut } from "./reducers/auth";

const getUserConfirmation = (dialogKey, callback) => {
  const dialogTrigger = window[Symbol.for(dialogKey)];
  if (dialogTrigger) {
    return dialogTrigger(callback);
  }
  callback(true);
};

export const history = createBrowserHistory({ getUserConfirmation });

// Middleware
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

// Root Reducer
const appReducer = createRootReducer(history);
const rootReducer = (state, action) => {
  if (action.type === signOut.type) {
    state = undefined
  }
  return appReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({ 
      thunk: false,
      immutableCheck: false,
      serializableCheck: false,
    }), 
    sagaMiddleware,
    routeMiddleware,
  ],
})
sagaMiddleware.run(rootSaga);

window[Symbol.for("Store")] = store

export default store;



// import createSagaMiddleware from "redux-saga";
// import {applyMiddleware, compose, createStore} from 'redux'
// import {createBrowserHistory} from "history";
// import {routerMiddleware} from 'connected-react-router'
// import rootSaga from "./sagas";
// import createRootReducer from './reducers'
// import { AuthActionType, SUCCESS } from "../const";

// export const history = createBrowserHistory();
// const routeMiddleware = routerMiddleware(history);
// const sagaMiddleware = createSagaMiddleware();
// const middlewares = [sagaMiddleware, routeMiddleware];

// const appReducer = createRootReducer(history);
// const rootReducer = (state, action) => {
//   if (action.type === AuthActionType.SIGN_OUT[SUCCESS]) {
//     state = undefined
//   }
//   return appReducer(state, action)
// }

// export default function configureStore(preloadedState) {
//   const store = createStore(
//     rootReducer,
//     preloadedState,
//     compose(
//       applyMiddleware(
//         routerMiddleware(history),
//         ...middlewares
//       ),
//       (window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) || compose
//     ),
//   );

//   sagaMiddleware.run(rootSaga);
//   return store;
// }
